import { HttpPromiseService } from './http-promise.service';
import { Injectable } from '@angular/core';
import { IViewCert } from '../interfaces/certificate.interface';
import { IDeclaration } from 'src/modules/authentication/interfaces/declaration.interface';
@Injectable({ providedIn: 'root' })

export class AttestationAndDeclarationService {

    constructor(
        private httpPromiseService: HttpPromiseService
    ) {

    }
    public updateDocumentValidityDate(certificateId: string, requestBody: {stafferId: string, type?: string, issueDate?: number, expiryDate?: number}) {
        return this.httpPromiseService.httpPutRequest(
            `/api/certificates/updateDocumentValidityDate/${certificateId}`,
            requestBody
        );
    }

    public doesContractorHasVSCWithinXYears(userId: string, certificateType: string, period: string, duration: string, isApprove?: boolean): Promise<IViewCert[]> {
        
        let url = `/api/certificates/checkCertificateByExpiryDateRange/${userId}?type=${certificateType.toString()}&period=${period}&duration=${duration}`;

        if (isApprove !== undefined) {
            url += `&isApprove=${isApprove}`;
        }
        return this.httpPromiseService.httpGetRequest(
            url
        );
    }

    public updateDeclarationSignedDate(stafferId: string, data: {type: string, certificateType?: string, issueDate?: number, certificateId?: string}): Promise<IDeclaration[]> {

        return this.httpPromiseService.httpPostRequest(
            `/api/attestationsAndDeclarations/${stafferId}`, data
        );
    }

    public generateRequestLetter(stafferId: string, timeZone: string, skills: string[], type: string, city: string) {
        return this.httpPromiseService.httpPostRequest(
            `/api/attestationsAndDeclarations/vsc-request/${stafferId}`, {
                timeZone,
                skills,
                type,
                city
            }
        );
    }

    public fetchContractorVSCProperties(stafferId: string) {
        return this.httpPromiseService.httpGetRequest(
            `/api/attestationsAndDeclarations/${stafferId}`
        );
    }

    public getVSCValidationStatus(stafferId: string, isApprove?: boolean): Promise<{
        hasVSCWithin6Months: boolean;
        hasVSCWithin3Years: boolean;
        hasReceiptWithin8Weeks: boolean;
        byPassVSCFlow: boolean;
        vscDeclarationExpiry: number | null;
        vscDeclarationLastSigned: number | null;
    }> {
        let url = `/api/certificates/vsc-validation-status/${stafferId}`;
        if (isApprove !== undefined) {
            url += `?isApprove=${isApprove}`;
        }
        return this.httpPromiseService.httpGetRequest(url);
    }
}

